import * as React from "react";
import { ReactNode } from "react";
import { Box, Row, Text } from "@stenajs-webui/core";
import { Icon } from "../../../icon/Icon";
import styles from "../MenuButton.module.css";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { cssColor } from "@stenajs-webui/theme";

export type MenuButtonContentProps =
  | MenuButtonContentLabelProps
  | MenuButtonContentRenderLabelProps;

export interface MenuButtonContentCommonProps {
  leftIcon?: IconDefinition;
  left?: ReactNode;
  color?: string;
  rightIcon?: IconDefinition;
  right?: ReactNode;
}

export interface MenuButtonContentLabelProps
  extends MenuButtonContentCommonProps {
  label: string;
}

export interface MenuButtonContentRenderLabelProps
  extends MenuButtonContentCommonProps {
  renderLabel: () => ReactNode;
}

export const MenuButtonContent: React.FC<MenuButtonContentProps> = ({
  leftIcon,
  left,
  right,
  rightIcon,
  color,
  ...props
}) => {
  return (
    <Row flex={1} gap={2} alignItems={"center"}>
      <MenuButtonAside
        content={left}
        icon={leftIcon}
        color={color ?? cssColor("--swui-text-primary-color")}
      />
      {"label" in props ? (
        <Text
          variant={"bold"}
          className={styles.label}
          color={color ?? cssColor("--swui-text-primary-color")}
        >
          {props.label}
        </Text>
      ) : (
        props.renderLabel()
      )}
      <MenuButtonAside
        content={right}
        icon={rightIcon}
        color={color ?? cssColor("--swui-text-primary-color")}
      />
    </Row>
  );
};

function MenuButtonAside({
  content,
  icon,
  color,
}: {
  content?: ReactNode;
  icon?: IconDefinition;
  color: string;
}) {
  if (content) {
    return <>{content}</>;
  } else if (icon) {
    return (
      <Box alignItems={"center"} justifyContent={"center"} width={"20px"}>
        <Icon icon={icon} size={20} color={color} data-hover={true} />
      </Box>
    );
  }

  return null;
}
